import React, { useState, useEffect, Fragment } from "react";
import { Card, Modal } from "react-bootstrap";
import { Row, Col } from "react-bootstrap";
import { AgGridReact } from "ag-grid-react";
import Swal from "sweetalert2";
import { toast } from "react-toastify";
import { slotscreate, slotsdetail, slotslist, slotsupdate, slotsvalidate } from "../../../services/master";
import { academylist } from "../../../services/admin";
import Select from "react-select";

export const SlotManagement = () => {
    // State variables
    const [filterSlot, setFilterSlot] = useState([]);
    const [SlotId, setSlotId] = useState(0);
    const [name, setName] = useState("");
    const [fromTime, setFromTime] = useState("");
    const [toTime, setToTime] = useState("");
    const [isBreak, setIsBreak] = useState('No');
    const [errorMessage, setErrorMessage] = useState("");
    const [alist, setAList] = useState([]);
    const [acaid, setAcaID] = useState("");
    // Fetch the list of slots
    useEffect(() => {
        academylist().then((res) => {
            if (res.status === true) {
                let arr = [];
                if (res.data.details.length > 0) {
                    for (let i = 0; i < res.data.details.length; i++) {
                        arr.push({
                            value: res.data.details[i].id,
                            label:
                                res.data.details[i].name + " - " + res.data.details[i].code,
                        });
                    }
                    setAList(arr);
                }
            }
        });
        funlist();
    }, []);

    function funlist() {
        setFilterSlot([]);
        slotslist().then((res) => {
            if (res.status === true) {
                setFilterSlot(res.data);
            }
        });
    }

    // Define column definitions for AgGrid
    const columnDefs = [
        {
            headerName: "Slot Name",
            width: 250,
            field: "name",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        },
        {
            headerName: "From Time",
            width: 180,
            field: "from_time",
            sortable: true,
            resizable: true,
            filter: true,
        },
        {
            headerName: "To Time",
            width: 180,
            field: "to_time",
            sortable: true,
            resizable: true,
            filter: true,
        },
        {
            headerName: "Is Break",
            width: 150,
            field: "is_break",
            sortable: true,
            resizable: true,
            filter: true,

        },
        {
            headerName: "Actions",
            width: 180,
            field: "id",
            resizable: true,
            filter: false,
            cellRenderer: function (params) {
                return (
                    <div className="text-center">
                        <a
                            onClick={() => viewSlot(params.value)}
                            className="btn-sm btn-info"
                        >
                            <i className="fa fa-edit"></i>
                        </a>
                    </div>
                );
            },
        },
    ];

    // Show modal for creating or editing a slot
    const [show, setShow] = useState(false);

    function handleshow() {
        setSlotId(0); // reset SlotId for new slot
        setName("");
        setFromTime("");
        setToTime("");
        setIsBreak('No');
        setErrorMessage("");
        setShow(true);
    }

    function handleclose() {
        setSlotId(0);
        setErrorMessage("");
        setShow(false);
    }

    function viewSlot(id) {
        setSlotId(id);
        setShow(true);
        setErrorMessage("");
        slotsdetail(id).then((response) => {
            if (response.status === true) {
                setName(response.data.name);
                setFromTime(response.data.from_time);
                setToTime(response.data.to_time);
                setIsBreak(response.data.is_break);
            }
        });
    }

    // Handle slot submission (create or update)
    function SubmitSlot() {
        setErrorMessage("");
        let valid = "";
        if (localStorage.getItem("Role") === "1") {
            if (acaid === "") {
                setErrorMessage("Please Select Academy");
                valid = "Please Select Academy";
            }
        } else {
            valid = "";
        }
        if(valid === ""){
 if (name) {
            if (fromTime) {
                if (toTime) {
                    if (isBreak) {
                        const temp = new FormData();
                        temp.append("name", name);
                        temp.append("from_time", fromTime);
                        temp.append("to_time", toTime);
                        temp.append("is_break", isBreak);
                        temp.append("id", SlotId);
                        if (localStorage.getItem("Role") === "1" && acaid !== "") {
                            temp.append("academy_id", acaid.value);
                        }
                        slotsvalidate(temp).then((response) => {
                            if (response.status === false) {
                                setErrorMessage(response.message);
                            } else {
                                const tempData = new FormData();
                                tempData.append("name", name);
                                tempData.append("from_time", fromTime);
                                tempData.append("to_time", toTime);
                                tempData.append("is_break", isBreak);
                                tempData.append("user_id", localStorage.getItem("UID"));
                                if (localStorage.getItem("Role") === "1" && acaid !== "") {
                                    tempData.append("academy_id", acaid.value);
                                }
                                if (SlotId === 0) {
                                    slotscreate(tempData).then((response) => {
                                        if (response.status === true) {
                                            handleclose();
                                            funlist();
                                            toast.success(response.message);
                                        } else {
                                            setErrorMessage(response.data.message);
                                        }
                                    });
                                } else {
                                    tempData.append("id", SlotId);
                                    slotsupdate(tempData).then((response) => {
                                        if (response.status === true) {
                                            handleclose();
                                            funlist();
                                            toast.success(response.message);
                                        } else {
                                            setErrorMessage(response.data.message);
                                        }
                                    });
                                }
                            }
                        });
                    }else{
                        setErrorMessage("Please Select Is Break");
                    }
                }else{
                    setErrorMessage("Please Enter To Time");
                }
            }else{
                setErrorMessage("Please Enter From Time");
            }
        } else {
            setErrorMessage("Please Enter Slot Name");
        }
        }
       
    }
    function handleAcademy(e) {
        if (e !== null) {
            setAcaID(e);
        } else {
            setAcaID("");
        }
    }



    return (
        <Fragment>
            <div className="page-header reported-header">
                <div>
                    <h2 className="main-content-title tx-24 mg-b-5">Slot List</h2>
                    <ol className="breadcrumb">
                        <li className="breadcrumb-item">
                            <a>Master</a>
                        </li>
                        <li className="breadcrumb-item active" aria-current="page">
                            Slot
                        </li>
                    </ol>
                </div>
            </div>

            <Row className="row-sm mx-0 mt-3">
                <Col xxl={12} lg={12} md={12}>
                    <Card className="custom-card overflow-hidden">
                        <Card.Body>
                            <div className="responsive">
                                <div className="res-right">
                                    <a
                                        onClick={handleshow}
                                        variant="success"
                                        type="button"
                                        className="btn my-1 me-2 btn-success tx-teko"
                                    >
                                        {" "}
                                        Add
                                    </a>
                                </div>
                                <div className="ag-theme-alpine ag-style">
                                    <AgGridReact
                                        columnDefs={columnDefs}
                                        rowData={filterSlot}
                                        pagination={true}
                                        paginationPageSize={10}
                                        sortingOrder={["asc", "desc"]}
                                        suppressDragLeaveHidesColumns={true}
                                    />
                                </div>
                            </div>

                            {/* Slot Modal */}
                            <Modal show={show}>
                                <Modal.Header>
                                    {SlotId === 0 ? <h4>Add Slot</h4> : <h4>Slot Details</h4>}
                                </Modal.Header>
                                <Modal.Body>
                                    <Row className="row-sm mx-0">
                                        {localStorage.getItem("Role") === "1" && (
                                            <Col lg={12} md={12}>
                                                <div className="form-label">
                                                    <label className="mb-2">
                                                        Select Academy
                                                        <span className="text-danger"> *</span>

                                                    </label>
                                                </div>
                                                <Select
                                                    className="default-select"
                                                    placeholder="Select Academy"
                                                    value={acaid}
                                                    options={alist}
                                                    onChange={handleAcademy}
                                                    isSearchable={true}
                                                    isClearable
                                                    hidden
                                                />

                                            </Col>
                                        )}
                                        <Col lg={12} md={12}>
                                            <div className="form-group">
                                                <label className="mb-2">
                                                    Slot Name <span className="text-danger"> *</span>
                                                </label>
                                                <input
                                                    type="text"
                                                    placeholder="Enter Slot Name"
                                                    value={name}
                                                    onChange={(e) => setName(e.target.value)}
                                                />
                                            </div>
                                            <div className="form-group">
                                                <label className="mb-2">
                                                    From Time <span className="text-danger"> *</span>
                                                </label>
                                                <input
                                                    type="text"
                                                    value={fromTime}
                                                    onChange={(e) => setFromTime(e.target.value)}
                                                />
                                            </div>
                                            <div className="form-group">
                                                <label className="mb-2">
                                                    To Time <span className="text-danger"> *</span>
                                                </label>
                                                <input
                                                    type="text"
                                                    value={toTime}
                                                    onChange={(e) => setToTime(e.target.value)}
                                                />
                                            </div>
                                            <div className="form-group">
                                                <label className="mb-2">
                                                    Is Break
                                                </label>
                                                <select
                                                    className="default-select  form-control wide"
                                                    value={isBreak}
                                                    onChange={(e) => setIsBreak(e.target.value)}
                                                >
                                                    <option value="" disabled>
                                                        Select Timetable Type
                                                    </option>
                                                    <option value="Yes">Yes</option>
                                                    <option value="No">No</option>
                                                </select>

                                            </div>
                                        </Col>

                                        {errorMessage !== "" && (
                                            <span className="text-danger">{errorMessage}</span>
                                        )}
                                    </Row>
                                </Modal.Body>
                                <Modal.Footer>
                                    <a
                                        onClick={SubmitSlot}
                                        className="btn btn-next btn-success"
                                        style={{ float: "right" }}
                                    >
                                        {SlotId === 0 ? "Submit" : "Update"}
                                    </a>
                                    <a
                                        className="btn btn-next btn-secondary"
                                        style={{ float: "right" }}
                                        onClick={handleclose}
                                    >
                                        Close
                                    </a>
                                </Modal.Footer>
                            </Modal>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </Fragment>
    );
};
